import { makeVar } from '@apollo/client'
import { CurrentUserFirmsProps } from '@deltek/specification-client/core/Models/currentUserInfo'
import { canShowBestPracticeSetting } from 'shared/utils/bestPracticeUtils'

export interface WorkspaceToggles {
    areSharedPropertiesVisible: boolean
}

const workspaceTogglesInitial = {
    areSharedPropertiesVisible: true,
}

export const workspaceToggles = makeVar<WorkspaceToggles>({
    ...workspaceTogglesInitial,
})

export const setAreSharedPropertiesVisible = (value: boolean) => {
    workspaceToggles({ areSharedPropertiesVisible: value })
}

// Reactive variable for showing/hiding the best practice setting pop-up.
export const showBestPracticeSetting = makeVar<boolean>(false)

// Function to set the reactive variable for showing/hiding the best practice setting pop-up.
export const setShowBestPracticeSetting = (userFirm: CurrentUserFirmsProps) => {
    if (!userFirm) {
        return
    }

    const setting = canShowBestPracticeSetting(userFirm)
    showBestPracticeSetting(setting)
}
